/* eslint react/no-unescaped-entities: off */
import React, { useEffect } from 'react';
import { Link } from 'gatsby';
import './PolicyPage.scss';
import PolicyHeader from './PolicyHeader';

export default (function TermsOfServicePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="return-policy-section">
      <PolicyHeader />
      <div className="container-fluid-policy">
        <div className="policy-head-title">
          <h1>Allgemeine Geschäftsbedingungen</h1>
        </div>
        <div className="section-body">
          <h2 className="first-h">Allgemeine Geschäftsbedingungen</h2>
          <p>GOBI Cashmere Europe GmbH.</p>

          <p style={{ display: 'flex', flexWrap: 'wrap' }}>
            ALLGEMEINE GESCHÄFTSBEDINGUNGEN (AGB) für Bestellungen über{' '}
            <a href="https://cdn.shopify.com/s/files/1/1953/2845/files/PDF_General_Terms_and_Conditions.pdf?v=1589517083">
              www.gobicashmere.com
            </a>
            &nbsp;&&nbsp;
            <a href="https://cdn.shopify.com/s/files/1/0282/0718/5965/files/700c2a65c1cd3334b6cb3ac98e69b353_1.pdf?v=1592820381">
              www.gobicashmere.com/ru
            </a>
            <br></br>
            <a href="https://cdn.shopify.com/s/files/1/0249/6551/3262/files/PDF_Allgemeine_Geschaftsbedingungen.pdf?v=1589516170">
              www.gobicashmere.com/de
            </a>
            &nbsp;&&nbsp;
            <a href="https://cdn.shopify.com/s/files/1/0273/5298/9833/files/General_Terms_and_Conditions_UK.pdf?v=1589783877">
              www.gobicashmere.com/uk
            </a>
            &nbsp;&&nbsp;
            <a href="https://cdn.shopify.com/s/files/1/0280/1834/4006/files/Ogolne_Zasady_1.pdf?v=1594258331">
              www.gobicashmere.com/pl
            </a>
            &nbsp;&&nbsp;
            <a href="https://cdn.shopify.com/s/files/1/0281/2906/7148/files/Termes_et_conditions_generale.pdf?v=1594016386">
              www.gobicashmere.com/fr
            </a>
          </p>
          <p>
            Für die Geschäftsbeziehungen zwischen&nbsp;GOBI&nbsp;Cashmere Europe GmbH&nbsp;(GOBI) und dem Warenkäufer
            über die Online-Verkaufsplattform&nbsp;
            <a href="https://gobicashmere.com/">www.gobicashmere.com</a> sowie für alle unsere Lieferungen und
            Leistungen gelten die nachfolgenden Allgemeinen Geschäftsbedingungen (AGB) in ihrer zum Zeitpunkt der
            Bestellung gültigen Fassung.
          </p>
          <p>
            Mit der Nutzung von www.gobicashmere.com oder der Bestellung erklären Sie sich mit diesen Allgemeinen
            Geschäftsbedingungen einverstanden. Bitte lesen Sie die Bedingungen sorgfältig durch, bevor Sie Ihre
            Bestellung aufgeben.
          </p>
          <p>
            Die Europäische Kommission bietet eine Plattform für die außergerichtliche Online-Streitbeilegung
            (OS-Plattform), die unter&nbsp;
            <a href="https://translate.googleusercontent.com/translate_c?depth=1&amp;hl=de&amp;rurl=translate.google.com&amp;sl=de&amp;sp=nmt4&amp;tl=en&amp;u=http://ec.europa.eu/consumers/odr/&amp;usg=ALkJrhhPFE1NGn9EEbpRhu_AsA647vCTMw">
              http://ec.europa.eu/consumers/odr/
            </a>
            &nbsp;verfügbar ist.
          </p>

          <p>GOBI ist nicht bereit, an Streitbeilegungsverfahren vor den Verbraucherbeschwerdebehörden teilzunehmen.</p>
          <p>
            Bei uns können nur volljährige Personen bestellen, die eine Wohnadresse in Deutschland haben und ihre
            Bestellung nicht für ihre gewerblichen oder selbständigen Tätigkeiten und für einen Dritten aufgeben.
            Unternehmer im Sinne des § 14 BGB sind nicht zur Bestellung berechtigt. Wir weisen ausdrücklich darauf hin,
            dass wir keine Rechnungen nach § 14 UStG ausstellen werden.
          </p>

          <h2>1. VERTRAGSABSCHLUSS UND WARENLIEFERUNG</h2>

          <p>1.1 Die Verträge auf www.gobicashmere.com werden ausschließlich in deutscher Sprache abgeschlossen.</p>
          <p>
            1.2 Die Präsentation der Waren auf unserer Website stellt kein bindendes Angebot von&nbsp;GOBI&nbsp;zum
            Abschluss eines Kaufvertrages dar.
          </p>
          <p>1.3 Im Folgenden sind die Schritte für Online-Bestellungen aufgeführt.</p>
          <ul>
            <li>Waren auswählen</li>
            <li>Geben Sie Ihre Kundendaten ein: Rechnungs- und Lieferanschrift</li>
            <li>Zahlungsart auswählen</li>
            <li>Informationen überprüfen und verifizieren (Name, Adresse, Zahlungsmethode, bestellte Artikel)</li>
            <li>Bestellung abschicken</li>
          </ul>

          <p>
            1.4 Mit dem Absenden des auf unserer Website zur Verfügung gestellten Bestellformulars durch Anklicken des
            Buttons&nbsp;"Bestellung absenden", geben Sie ein verbindliches Angebot auf Abschluss eines Kaufvertrages
            mit uns ab.&nbsp;GOBI&nbsp;sendet Ihnen eine E-Mail, die den Eingang Ihrer Bestellung bei uns und die
            Details Ihrer Bestellung (Auftragsbestätigung) bestätigt. Diese Auftragsbestätigung stellt keine
            Annahmeerklärung Ihres Vertragsangebots dar, sondern dient lediglich der Information.
          </p>
          <p>
            1.5 Der Kaufvertrag zwischen Ihnen und&nbsp;GOBI&nbsp;kommt nur zustande, wenn wir die Annahme des
            Kaufangebots ausdrücklich erklären oder den Versand der Ware durch eine separate E-Mail bestätigt haben.
          </p>
          <p>
            1.6 Ist eine Lieferung der von Ihnen bestellten Ware nicht möglich, z.B. weil die bestellte Ware nicht auf
            Lager ist,&nbsp;wird GOBI&nbsp;eine Annahmeerklärung&nbsp;nicht&nbsp;annehmen. Ein Vertrag kommt in diesem
            Fall nicht zustande. GOBI wird Sie hierüber unverzüglich informieren und bereits erhaltene Gegenleistungen
            unverzüglich zurückerstatten. GOBI ist nur verpflichtet, aus seinem Warenbestand zu liefern. Wir übernehmen
            nicht das Risiko der Beschaffung eines bestellten Produkts (Beschaffungsrisiko).
          </p>
          <p>
            1.7 GOBI ist berechtigt, ein Angebot ohne Angabe von Gründen abzulehnen, insbesondere wenn der begründete
            Verdacht besteht, dass die über das Internet erworbenen Waren gewerblich weiterverkauft werden sollen.
          </p>

          <h2>2. PREISE, VERSAND UND VERSANDKOSTEN</h2>

          <p>
            2.1 Es gelten die im Angebot zum Zeitpunkt der Bestellung angegebenen Preise. Die angegebenen Preise sind
            Endpreise, d.h. sie enthalten die jeweils gültige deutsche Mehrwertsteuer. Zusätzlich werden Versandkosten
            berechnet. Die Ware bleibt bis zur vollständigen Bezahlung des Kaufpreises unser Eigentum.
          </p>
          <p>
            2.2 Verkaufsaktionen <br></br>
            Am Ende einer Verkaufsaktion oder eines Verkaufsangebots von GOBI können nachfolgende Angebote die gleichen
            oder ähnlichen Verkaufsaktionen oder angebotenen Produkte enthalten. Darüber hinaus kann jedes Angebot eine
            unterschiedliche Laufzeit mit einem unterschiedlichen Verkaufskonzept haben.
          </p>
          <p>
            2.3 Die Versandkosten innerhalb Deutschlands betragen €5 und in die EU Länder €9. In andere europäischen
            Länder kostet der Versand €20. Die Versandkosten variieren für andere Länder.
          </p>
          <p>
            2.4 Der Versand erfolgt in Deutschland entweder per DHL-Standard oder DpD-Standard. Das Transportrisiko
            trägt&nbsp;GOBI. Die Ware ist am nächsten Tag der Bestellung versandbereit. Sofern nicht anders vereinbart,
            erfolgt die Lieferung innerhalb von 1 bis 5 Werktagen an die vom Kunden angegebene Lieferadresse. In den
            folgenden Fällen kann sich der Versand verzögern;
          </p>
          <ul>
            <li>Die Zahlung wurde nicht vollständig auf unserem Konto gutgeschrieben</li>
            <li>Hohes Risiko von Betrug oder Zahlungsproblemen</li>
            <li>Lieferadresse fehlt / falsch</li>
          </ul>

          <p>
            2.5 Obwohl wir uns bemühen, die Lieferung innerhalb der angegebenen Frist sicherzustellen, kann die
            Lieferung aufgrund unvorhergesehener Ereignisse länger dauern. Für den unwahrscheinlichen Fall, dass die
            Lieferung länger als zwei Wochen dauert, können Sie die Bestellung stornieren.
          </p>
          <p>
            2.6 Wenn Sie mehrere Produkte gleichzeitig bestellt haben, können einzelne Produkte zu verschiedenen Zeiten
            geliefert werden. Die Versandkosten werden nur einmalig berechnet.
          </p>

          <h2>3. ZAHLUNG</h2>

          <p>3.1 1 Zahlungsmethoden;</p>
          <ul>
            <li>Vorauszahlung (3.2)</li>
            <li>Kreditkarte (3.3)</li>
          </ul>

          <p>
            Wir behalten uns das Recht vor, bestimmte Zahlungsarten nicht anzubieten und auf andere Zahlungsarten zu
            verweisen. Bitte beachten Sie, dass wir nur Zahlungen von Konten innerhalb der Europäischen Union
            akzeptieren (EU). Etwaige Kosten einer Geldtransaktion sind von Ihnen zu tragen.
          </p>
          <p>
            3.2 Wenn Sie die Zahlungsart "Vorauskasse" wählen, teilen wir Ihnen in der Auftragsbestätigung unsere
            Bankverbindung mit. Der Rechnungsbetrag ist innerhalb von 10 Tagen auf unser Konto zu überweisen.
          </p>
          <p>
            3.3 Im Falle eines Kaufs mit Kreditkarte erfolgt die Belastung Ihres Kreditkartenkontos mit dem Absenden der
            Bestellung durch uns.
          </p>
          <p>
            3.4 Kommen Sie mit einer Zahlung in Verzug, sind Sie verpflichtet, die gesetzlichen Verzugszinsen in Höhe
            von 5% über dem Basiszinssatz zu zahlen. Für jede Mahnung, die Ihnen nach Eintritt der Verzögerung zugesandt
            wird, wird eine Mahngebühr von € 2,50 erhoben. Sie haben das Recht nachzuweisen, dass ein wesentlich
            geringerer Schaden als die Pauschale oder kein Schaden entstanden ist.
          </p>
          <p>3.5 Sie stimmen zu, dass Sie Rechnungen und Gutschriften nur in elektronischer Form erhalten.</p>
          <p>
            3.6 Ihre Bestelldaten werden von uns im Rahmen der gesetzlichen Bestimmungen gespeichert. Sie können den
            Vertragstext Ihrer Bestellung vor dem Absenden Ihrer Bestellung an uns ausdrucken, indem Sie im letzten
            Schritt Ihrer Bestellung auf "Drucken" klicken. Sie erhalten außerdem eine Auftragsbestätigung mit allen per
            E-Mail angegebenen Daten sowie eine Version des Muster-Widerrufsformulars, die ausgedruckt werden kann.
          </p>
          <p>
            Die personenbezogenen Daten, die Sie uns bei der Auftragserteilung per E-Mail übermitteln, werden
            ausschließlich zur Korrespondenz mit Ihnen und nur für den Zweck verarbeitet, für den Sie uns die Daten zur
            Verfügung gestellt haben (z.B. Daten zur Lieferung an die Spedition, Daten zur Zahlung an das beauftragte
            Kreditinstitut).
          </p>
          <h2>4. Farbhinweise</h2>
          <p>
            Die tatsächlichen Farben des Produkts können aufgrund verschiedener PC-Bildschirme und unterschiedlicher
            Beleuchtung (z.B. Studiobeleuchtung vs. Tageslicht) anders erscheinen. Die Bildschirme sind nicht alle
            gleich kalibriert, wodurch wir leider nicht garantieren können, dass die Farbwiedergabe von unseren
            Produktfotos im Online-Shop auf allen Bildschirmen nicht gleich aussieht. Wir tun unser Bestes, um
            sicherzustellen, dass unsere Produktfarben dem genauen Produkt so nahe wie möglich kommen. Wie bereits oben
            erwähnten, können wir keine 100%ige Garantie geben, dass die Produktfotos eine exakte Nachbildung ist.
          </p>
          <h2>5. RECHTLICHES WIDERRUFSRECHT</h2>

          <p>Beim Kauf von&nbsp;GOBI Produkten haben Sie ein gesetzliches Widerrufsrecht:</p>
          <p>
            Das Widerrufsrecht gilt ausschließlich gegenüber Verbrauchern gemäß § 13 BGB. Verbraucher ist jede
            natürliche Person, die eine Transaktion eingeht zu einem Zweck abschließt, der ihrer gewerblichen oder
            selbständigen beruflichen Tätigkeit nicht zugerechnet werden kann.
          </p>
          <p>
            Wir möchten Sie vorab darauf hinweisen, dass Sie im Falle einer Warenrücksendung den Retourenaufkleber
            verwenden können, den Sie von Ihrem Kundenkonto ausdrucken können. Wenn Sie keinen Drucker haben, wenn Sie
            Probleme beim Herunterladen des Rücksendeaufklebers haben oder wenn Sie einen neuen Rücksendeaufkleber
            benötigen, können Sie diesen über unsere Kundendienstabteilung anfordern (Kontaktdaten siehe unten). Bitte
            helfen Sie uns, unnötige Kosten zu vermeiden und die Ware nicht ohne Rücksendeetikett zurückzusenden.
          </p>

          <h2>WIDERRUFSBELEHRUNG</h2>

          <p>
            Sie haben das Recht, diesen Vertrag innerhalb einer Frist von vierzehn Tagen ohne Angabe von Gründen zu
            widerrufen. Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag, an dem Sie oder ein von Ihnen benannter
            Dritter, mit Ausnahme des Spediteurs, die Ware in Besitz genommen hat, oder bei Teillieferungen die letzte
            Lieferung.
          </p>
          <p>Um von Ihrem Widerrufsrecht Gebrauch zu machen, müssen Sie an</p>

          <p>
            GOBI Cashmere Europe GmbH <br></br>
            Genshagener Str. 27, <br></br>
            Halle 4, <br></br>
            14974 Ludwigsfelde <br></br>
            Deutschland<br></br>
            <span>Tel: +49 (0) 33 7934 189 32</span>
            <br></br>
            <span>
              E-Mail:&nbsp;<a href="mailto:berlin@gobi.mn">berlin@gobi.mn</a>
            </span>
          </p>

          <p>
            wenden, um Ihre Entscheidung, diesen Vertrag zu widerrufen. Sie können das beigefügte
            Muster-Widerrufsformular verwenden. Dies ist nicht zwingend erforderlich.
          </p>
          <p>
            Sie können das Muster-Widerrufsformular oder eine andere klare Aussage auch elektronisch über das
            Kontaktformular auf unserer Website ausfüllen und absenden.
          </p>
          <p>
            Wenn Sie diese Möglichkeit nutzen, senden wir Ihnen umgehend eine Bestätigung über den Eingang Ihres
            Widerrufs (z.B. per E-Mail). Zur Wahrung der Widerrufsfrist genügt es, wenn Sie die Mitteilung über die
            Ausübung des Widerrufsrechts vor Ende der Widerrufsfrist absenden.
          </p>

          <h2>KONSEQUENZEN DER REVISION</h2>

          <p>
            Wenn Sie diese Vereinbarung widerrufen, müssen wir Ihnen diese unverzüglich, spätestens jedoch innerhalb von
            vierzehn Tagen nach Eingang der Mitteilung über Ihren Widerruf dieses Vertrages zurückzahlen. Für eine
            solche Rückzahlung verwenden wir die gleichen Zahlungsmittel wie bei der ursprünglichen Transaktion, es sei
            denn, Sie haben ausdrücklich etwas anderes vereinbart. In keinem Fall werden Ihnen wegen dieser Rückzahlung
            Entgelte berechnet.
          </p>
          <p>
            Wir können die Rückzahlung verweigern, bis Sie die Ware zurückgegeben haben oder bis Sie nachgewiesen haben,
            dass Sie die Ware zurückgegeben haben, je nachdem, welcher Zeitpunkt früher liegt.
          </p>
          <p>
            Sie müssen die Ware unverzüglich, spätestens jedoch vierzehn Tage nach dem Datum, an dem Sie uns über den
            Widerruf dieses Vertrages informieren, an uns zurücksenden.
          </p>
          <p>
            Die Frist ist eingehalten, wenn Sie die Ware vor Ablauf der Frist von 14 Tagen versenden. Wir tragen die
            Kosten der Rücksendung der Ware, wenn Sie das von uns zur Verfügung gestellte Rücksendeetikett für eine
            Rücksendung &nbsp;innerhalb Deutschlands verwenden.
          </p>
          <p>
            Andernfalls sind die Rücksendekosten von Ihnen zu tragen. Für einen etwaigen Wertverlust der Ware sind Sie
            nur dann verantwortlich, wenn dieser Wertverlust auf eine Behandlung zurückzuführen ist, die nicht zum
            Zwecke der Überprüfung der Art, Zusammensetzung, Eigenschaften und Funktion der Ware erforderlich ist.
          </p>

          <h2>MUSTER WIDERRUFSFORMULAR</h2>

          <p>
            Wenn Sie den Vertrag widerrufen möchten, füllen Sie bitte dieses Formular aus und senden Sie es an uns
            zurück:&nbsp;
          </p>

          <p>
            GOBI Cashmere Europe GmbH <br></br>
            Genshagener Str. 27, <br></br>
            Halle 4, <br></br>
            14974 Ludwigsfelde <br></br>
            Deutschland<br></br>
            <span>Tel: +49 (0) 33 7934 189 32</span>
            <br></br>
            <span>
              E-Mail:&nbsp;<a href="mailto:berlin@gobi.mn">berlin@gobi.mn</a>
            </span>
          </p>

          <p>
            Ich / wir (*) widerrufen hiermit den von mir / uns (*) abgeschlossenen Vertrag über den Kauf folgender Waren
            (*) /
          </p>

          <ul style={{ listStyleType: 'none' }}>
            <li>- Bestellt am (*) / empfangen am (*)</li>
            <li>- Name des Kunden (der Kunden)</li>
            <li>- Adresse des Kunden (der Kunden)</li>
            <li>- Datum</li>
            <li>(*) Gegebenenfalls löschen</li>
          </ul>

          <p>Ende der Widerrufsbelehrung</p>

          <h2>6. RÜCKZAHLUNGEN</h2>

          <p>
            Alle Rückzahlungen werden automatisch auf das Konto vorgenommen, das Sie für die Zahlung verwendet haben.{' '}
          </p>
          <ul>
            <li>
              Bei Zahlung per Vorkasse erfolgt die Umbuchung auf das Konto, von dem aus die Überweisung erfolgt ist.{' '}
            </li>
            <li>
              Bei Zahlung mit PayPal oder Kreditkarte erfolgt die Rückerstattung an das zugehörige PayPal- oder
              Kreditkartenkonto.
            </li>
          </ul>

          <h2>7. KUNDENBETREUUNG</h2>

          <p style={{ marginBottom: '10px' }}>Unser Service ist wie folgt:</p>

          <p>
            GOBI Cashmere Europe GmbH <br></br>
            Genshagener Str. 27, <br></br>
            Halle 4, <br></br>
            14974 Ludwigsfelde <br></br>
            Deutschland<br></br>
            <span>Tel: +49 (0) 33 7934 189 32</span>
            <br></br>
            <span>
              E-Mail:&nbsp;<a href="mailto:berlin@gobi.mn">berlin@gobi.mn</a>
            </span>
          </p>

          <p>
            Sie erreichen uns von Montag bis Samstag von 11 bis 18 Uhr (außer Dienstags und an gesetzlichen Feiertagen).
            Anrufe aus dem deutschen Festnetz zum Stadttarif, Preise aus dem Mobilfunknetz ggf. abweichend (je nach
            Anbieter).
          </p>

          <h2>8. GESETZLICHE HAFTUNG FÜR MÄNGEL, RECHTSWAHL UND WIRKSAMKEIT</h2>

          <p>
            8.1 Für alle Rechtsstreitigkeiten aus oder im Zusammenhang mit dem Kaufvertrag gilt ausschließlich deutsches
            Recht unter Ausschluss des UN-Kaufrechts.
          </p>
          <p>8.2 Erfüllungsort ist Berlin.</p>
          <p>
            8.3 Sollten eine oder mehrere Bestimmungen unwirksam sein, so wird dadurch die Gültigkeit der übrigen
            Bestimmungen nicht berührt.
          </p>

          <h2>ANBIETER UND AUFTRAGNEHMER:</h2>

          <p>
            <span>GOBI&nbsp;Cashmere Europe&nbsp; GmbH</span>
            <br></br>
            <span>Büro &amp; Logistikzentrum</span>
            <br></br>
            <span>Genshagener Str. 27</span>
            <br></br>
            <span>Halle 4</span>
            <br></br>
            <span>14974 Ludwigsfelde</span>
            <br></br>
            <span>Deutschland</span>
            <br></br>
            <span>Tel: +49 (0) 33 7934 189 32</span>
            <br></br>
            <span>
              E-Mail:&nbsp;<a href="mailto:infoshop@gobi.mn">berlin@gobi.mn</a>
            </span>
          </p>

          <p>
            <span>Geschäftsführer: Amarsaikhan Baatarsaikhan</span>
            <br></br>
            <span>Eingetragen beim Amtsgericht Cottbus</span>
            <br></br>
            <span>HRB 12839 CB</span>
            <br></br>
            <span>UMSATZSTEUER-ID: DE 815655506</span>
            <br></br>
            <span>Datum: 24.12.2019</span>
          </p>

          <a href="https://cdn.shopify.com/s/files/1/0249/6551/3262/files/Untitled_document_3.pdf?v=1602838869">
            <p>*GTC PDF-Download</p>
          </a>
        </div>
      </div>
    </div>
  );
});
